'use strict'

const API_BASE = 'https://tossp.yoooooo.com/index.php/index/app_version/'

function createAppVersionApi (http, FormDataType) {
  const FormDataConstructor = FormDataType || FormData

  function request (url, body) {
    return http.post(url, body)
      .then(function (response) {
        const payload = response && response.data
        if (!payload || payload.code !== 0) {
          throw new Error(payload && payload.message ? payload.message : '请求失败')
        }
        return payload.data
      })
      .catch(function (error) {
        const payload = error && error.response && error.response.data
        if (payload && payload.message) {
          throw new Error(payload.message)
        }
        throw error instanceof Error ? error : new Error('请求失败')
      })
  }

  return {
    list () {
      return request(API_BASE + 'versionList', new FormDataConstructor())
    },

    upload (input) {
      const formData = new FormDataConstructor()
      formData.append('apkName', input.apkName)
      formData.append('versionCode', input.versionCode)
      formData.append('versionName', input.versionName)
      formData.append('releaseNotes', input.releaseNotes)
      formData.append('forceUpdate', input.forceUpdate ? '1' : '0')

      return request(API_BASE + 'upload', formData)
    },

    deleteVersion (id) {
      const formData = new FormDataConstructor()
      formData.append('id', id)

      return request(API_BASE + 'delete', formData)
    }
  }
}

export { createAppVersionApi }



// WEBPACK FOOTER //
// ./src/api/appVersion.js